import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export default function getPropertiesAdditionnalData(idList) {
  const url = `${process.env.ASSETS_BASE_URI}/properties/his_data`;
  return Client.post(
    url,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.properties_data;
    })
    .catch(errorHandler);
}
